<template>
  <el-dropdown
    split-button
    :type="type"
    :size="size"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ label }}
    <template #dropdown>
      <el-dropdown-menu>
        <slot />
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
const emit = defineEmits(['click']);

defineProps({
  label: String,
  type: { type: String, default: 'primary' },
  size: { type: String, default: 'default' },
  disabled: Boolean,
});

const handleClick = () => {
  emit('click');
};
</script>

<style scoped></style>
